module.exports = __webpack_public_path__ + "img/830.b2347b26.svg";